var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.widePromo'] = (function () {
    'use strict';

    const CONFIG = {
        IMAGE_SELECTOR: '.block-wide-promo__image > img',
        IMAGE_ANIMATION: 'animate__slideInRight',
        FEATURE_SELECTOR: '.block-wide-promo__feature',
        FEATURE_ANIMATION: 'animate__zoomIn',
        FEATURE_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        const hasImage = block.querySelectorAll(CONFIG.IMAGE_SELECTOR).length > 0;
        const hasFeatures = block.querySelectorAll(CONFIG.FEATURE_SELECTOR).length > 0;
        if (!hasImage && !hasFeatures) return;

        const targets = [];
        if (hasImage) {
            targets.push({ selector: CONFIG.IMAGE_SELECTOR, type: CONFIG.IMAGE_ANIMATION, stagger: 0 });
        }
        if (hasFeatures) {
            targets.push({ selector: CONFIG.FEATURE_SELECTOR, type: CONFIG.FEATURE_ANIMATION, stagger: CONFIG.FEATURE_STAGGER });
        }

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            targets,
            overflow: true
        });
    };

    return {
        initialize
    };

})();
